(() => {
	/**
	 * Card Grid — Load More.
	 *
	 * The template renders every card visible and the button hidden (see
	 * block-card-grid.php); this script inverts that on load. Nothing is
	 * withheld from a visitor without JavaScript, and nothing is offered that
	 * JavaScript isn't there to deliver.
	 *
	 * Cards are hidden with the `hidden` attribute rather than by clipping or
	 * collapsing them, so they leave the accessibility tree and the tab order
	 * together — a card a sighted visitor can't see is not one a keyboard can
	 * still land in.
	 *
	 * On each press the first newly revealed card takes focus. Without that,
	 * focus stays on the button, which has just travelled down the page ahead
	 * of content the visitor has no way of knowing arrived; the polite live
	 * region says how much of the set is now showing.
	 */
	document.querySelectorAll('.block-card-grid[data-load-more]').forEach((grid) => {
		const items = grid.querySelector('.block-card-grid__items');
		const footer = grid.querySelector('.block-card-grid__footer');
		const button = grid.querySelector('[data-load-more-button]');
		const status = grid.querySelector('[data-load-more-status]');

		if (!items || !footer || !button) return;

		// ACF wraps inner blocks in `.acf-innerblocks-container`, which is
		// `display: contents` globally (see _global.scss) -- so the cards lay
		// out as children of the grid but sit a level deeper in the DOM.
		const container = items.querySelector(':scope > .acf-innerblocks-container') || items;
		const cards = Array.from(container.children);
		const batch = Math.max(1, parseInt(grid.dataset.loadMore, 10) || 1);
		const initial = Math.max(1, parseInt(grid.dataset.loadMoreInitial, 10) || batch);

		// Nothing to reveal: leave every card showing and the button hidden,
		// rather than printing a control that would do nothing.
		if (cards.length <= initial) return;

		let shown = initial;

		const paint = () => {
			cards.forEach((card, index) => {
				card.hidden = index >= shown;
			});
		};

		const reveal = () => {
			const from = shown;
			const firstNew = cards[from];

			shown = Math.min(cards.length, shown + batch);
			paint();

			// Number each card within the batch so the stylesheet can stagger
			// them off one delay; the class is dropped again once it has run,
			// which keeps a card that reveals twice from replaying stale state.
			for (let i = from; i < shown; i++) {
				const card = cards[i];
				card.style.setProperty('--reveal-index', i - from);
				card.classList.add('is-revealing');
				card.addEventListener('animationend', () => {
					card.classList.remove('is-revealing');
					card.style.removeProperty('--reveal-index');
				}, { once: true });
			}

			// Focus moves before the button can be hidden, so the last press
			// never drops focus to the top of the document.
			if (firstNew) {
				firstNew.setAttribute('tabindex', '-1');
				firstNew.focus();
			}

			footer.hidden = shown >= cards.length;

			if (status) {
				status.textContent = `Showing ${shown} of ${cards.length}.`;
			}
		};

		paint();
		footer.hidden = false;
		button.addEventListener('click', reveal);
	});
})();
